import React from 'react';
import { Link } from 'react-router-dom';
import { Pencil, Facebook, LogOut, Shield, Crown, User } from 'lucide-react';
import { useAuth, USER_ROLES } from '../../context/AuthContext';
import RoleSwitcher from '../RoleSwitcher';

const Header = ({ onLogout }) => {
  const { user, isAdmin, isPaid, isFree } = useAuth();

  const getRoleIcon = () => {
    if (isAdmin) return <Shield size={14} className="text-red-400" />;
    if (isPaid) return <Crown size={14} className="text-yellow-400" />;
    return <User size={14} className="text-gray-400" />;
  };

  const getRoleBadge = () => {
    if (isAdmin) return 'bg-red-600/20 text-red-400 border-red-600/50';
    if (isPaid) return 'bg-yellow-600/20 text-yellow-400 border-yellow-600/50';
    return 'bg-gray-600/20 text-gray-400 border-gray-600/50';
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-[60px] bg-[#0f0f15] border-b border-gray-800 flex items-center justify-between px-6 z-50">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg bg-purple-600 flex items-center justify-center">
          <Pencil size={18} className="text-white" />
        </div>
        <span className="text-purple-400 font-bold text-xl">CONNECT AI Magic</span>
      </Link>

      {/* Right Section */}
      <div className="flex items-center gap-4">
        {/* Role Switcher for Demo */}
        <RoleSwitcher />

        {/* FB Group Link */}
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
        >
          <Facebook size={16} />
          <span className="text-sm hidden md:inline">Join FB Group</span>
        </a>

        {/* User with Role Badge */}
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full border ${getRoleBadge()}`}>
          {getRoleIcon()}
          <span className="text-sm">{user?.name}</span>
        </div>

        {/* Admin Link */}
        {isAdmin && (
          <Link
            to="/admin"
            className="flex items-center gap-2 text-red-400 hover:text-red-300 transition-colors"
          >
            <Shield size={16} />
            <span className="text-sm">Admin</span>
          </Link>
        )}

        {/* Logout */}
        <button
          onClick={onLogout}
          className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
        >
          <LogOut size={16} />
          <span className="text-sm hidden md:inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
